import React, { memo } from 'react'
import { Handle } from '@xyflow/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faUserPlus } from '@fortawesome/free-solid-svg-icons'

const PositionNode = ({ data }) => {
    const { label, onClickIcon2 } = data
    return (
        <div className="positionNode">
            <div className="positionNode-label">{label}</div>
            <span onClick={onClickIcon2} className="positionNode-trash">
                <FontAwesomeIcon icon={faTrash} />
            </span>
            <Handle type="source" position="bottom" />
            <Handle type="target" position="top" />
        </div>
    )
}

export default memo(PositionNode)
